// extracted by css-extract-rspack-plugin
export default {"icon":"Search_icon__UfSv4","pointer":"Search_pointer__NwRoG"};